import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { initGTM } from '../hooks/useGoogleAnalytics';
import { useConsent } from '../thirdParty/consent/ConsentProvider';
import { CONSENT_SERVICENAME_GA4 } from '../thirdParty/consent/consent.types';

export function TrackingInit({ gaId, gtmId, cmpEnabled }: { gaId?: string; gtmId?: string; cmpEnabled: boolean }) {
    const { ready, hasConsent } = useConsent();

    // GTM nur laden, wenn ein Consent Manager verwendet wird
    useEffect(() => {
        if (!cmpEnabled || !gtmId) return;
        if (!(window as any).__gtm_init_done) {
            initGTM(gtmId); // dein bestehender Hook
            (window as any).__gtm_init_done = true;
        }
    }, [cmpEnabled, gtmId]);

    // GA4 NICHT vor Consent initialisieren
    useEffect(() => {
        if (!cmpEnabled || !gaId) return;
        if (!ready) return;

        // Siehe consentManagement -> vendorMap aus den appProps
        // Backend: "vendorMap": { "GoogleAnalytics4": "Google Analytics 4" }
        // -> Adapter mappt "GoogleAnalytics4" korrekt auf UC-Service
        if (hasConsent({ services: [CONSENT_SERVICENAME_GA4] })) {
            if (!(window as any).__ga_init_done) {
                ReactGA.initialize(gaId);
                console.log('Google Analytics INITIALIZED');
                (window as any).__ga_init_done = true;
            }
        }
    }, [cmpEnabled, gaId, ready, hasConsent]);

    return null;
}
